import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import AdvertiserForm from './AdvertiserForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewAdvertiserModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( { advertiser } ) => {
        this.setState( { fetching: true }, () => {
            this.props.createAdvertiser( {
                advertiser_name: advertiser.advertiser_name,
                domains: advertiser.domains,
                affiliates: [{
                    affiliateid: this.props.affiliate.affiliateid,
                    advertiser_affiliateid: this.props.advertiser.advertiserId,
                    deeplinkable: null,
                }],
            } )
            .then( ( newAdvertiser ) => {
                this.setState( { fetching: false } );
                this.props.onSubmit && this.props.onSubmit( newAdvertiser );
            } );
        } );
    }
    render() {
        const { advertiser, affiliate } = this.props;
        const initialValues = {
            affiliateType: affiliate.affiliateType,
            advertiser_name: advertiser.advertiserName,
            advertiserDomainsText: '',
        };
        if ( advertiser && advertiser.domains ) {
            initialValues.advertiserDomainsText = advertiser.domains.join('\n');
        }
        return (
            <DLModal title='New Advertiser'
            closeHandler={ this.props.closeModal }>
                <div>
                    <AdvertiserForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createAdvertiser: ( data ) => {
            return dAPI.post( '/affiliates/dbadvertisers', data );

        },
    };
};

export default connect( null, mapDispatchToProps )( NewAdvertiserModal );
